import Vue from 'vue';

//format関数の埋め込み
if (!String.format) {
    String.format = (template:string, ...args: any[]) =>{
        return template.replace(/{(\d+)}/g, (match, number) =>{ 
        return typeof args[number] != 'undefined' ? args[number]: match;
        });
    }
}

//グローバル辞書
export const words : { [key: string]: string } ={};

const plugin = {
  
  install() {
    
    //グローバル辞書の注入=>廃止
    // Object.defineProperty(Vue.prototype, '$words', {
    //   get() {
    //     return words;
    //   },
    // });

    Vue.prototype.$translate = (word:string) =>
    {
      // |で連結されたキーを変換
      if (word && word.indexOf("|") > -1){
        var results = new Array<string>();
        word.split('|').forEach(obj =>results.push(obj in words ? words[obj] : obj));
        return results.join('');
      } 
      //キーがある場合は変換し、ない場合はそのまま返す
      else if (word in words) return words[word];
      else return word;    
    }
  },
};

export default plugin;